import React, { useMemo } from "react";
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApiError } from "go-core/api/types";
import { CustomValidationConfig, CustomValidationConstraint, CustomValidationError } from "go-form/services/types";

interface Props {
	formErrors: Record<string, any>;
	register: UseFormRegister<any>;
	watch: UseFormWatch<any>;
	apiErrors: ApiError[];
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<any>[]>>;
}

const ItemsError = ({ apiErrors, formErrors, register, watch, setErrors }: Props) => {
	const { t } = useTranslation();

	const itemCountValidationConfig = useMemo(
		() => ({
			types: [
				{
					constraint: CustomValidationConstraint.GREATER_THAN,
					minValue: 1,
					customErrorMessage: "items_must_not_be_empty",
				},
			],
			setErrors,
			utils: { watch },
		}),
		[setErrors, watch]
	) satisfies CustomValidationConfig;

	const hasApiErrors = apiErrors?.find((err) => err?.code === "items_must_not_be_empty");

	if (hasApiErrors) {
		return (
			<div className="invalid-feedback ms-0" style={{ display: "inline" }}>
				{t("constraints.items_must_not_be_empty")}
			</div>
		);
	}

	return (
		<FormInput
			type="hidden"
			name="items_count"
			errors={formErrors}
			register={register}
			customValidationConfig={itemCountValidationConfig}
			value={watch("items").length}
		/>
	);
};

export default ItemsError;
